// Quote template variants (V2 wiring). Manual, engine-agnostic — the field is
// persisted on the quote and the renderer resolves it to a template + accent.
export const QUOTE_VARIANTS = [
  { key: "light-mono",      label: "Light Mono",       desc: "White / black / grey · orange accent" },
  { key: "light-navy",      label: "Light Navy",       desc: "One-page proposal · navy / brass" },
  { key: "proposal-blue",   label: "Proposal Blue",    desc: "Full navy / brass proposal pack (5 pages)" },
  { key: "email",           label: "Email",            desc: "Inbox version (T5)" },
  { key: "proforma",        label: "Pro Forma Invoice", desc: "Proposal Blue look · CWP number · payment before dispatch" },
];
export const isProforma = (k) => k === "proforma";
export const DEFAULT_VARIANT = "light-mono";
export const variantLabel = (k) =>
  (QUOTE_VARIANTS.find((v) => v.key === k) || QUOTE_VARIANTS[0]).label;
